import React from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';

var tr = require('ts-translate-js').default.boundTR;
var modal = require('../modal');

class PasswordReset extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            email: null,
            showSuccessResetPasswordModal: false,
            showFailedResetPasswordModal: false
        };

        this.handleOnResetOK = this.handleOnResetOK.bind(this);

        this.modalContainerRef = React.createRef();
    }

    handleOnConfirm() {
        const emailToUse = this.getEmailToUse()
        this.actionRequest = tsapp.mvcapi.postCtl("login/SendResetPasswordEmail", {email:emailToUse})
                                        .success(
                                            function(){
                                                this.setState({
                                                    showSuccessResetPasswordModal: true,
                                                    showFailedResetPasswordModal: false
                                                })
                                            }.bind(this))
                                        .notSuccess(
                                            function(){
                                                this.setState({
                                                    showSuccessResetPasswordModal: false,
                                                    showFailedResetPasswordModal: true
                                                })
                                            }.bind(this))
    }

    handleOnCancel(){
        this.props.onCancelResetPassword()
    }

    handleOnKeyPress(e){
        if (e.key === 'Enter') {
            this.handleOnConfirm()
        }
    }

    handleOnChangeEmailPassword(e){
        this.setState({ email: e.target.value })
    }

    handleOnResetOK() {
        this.setState({
            showSuccessResetPasswordModal: false,
            showFailedResetPasswordModal: false
        })
        this.props.onConfirmResetPassword();
    }

    getEmailToUse() {
        return (this.state.email != null) ? this.state.email : this.props.email;
    }

    getHeadersForInteg(integ) {
        if (integ === "rese") {
            return (
                <div>
                    <h2 className="col-md-12">{tr("Mot de passe oublié ?")}</h2>
                    <br/>
                    <div className="content-text">
                        <div className="col-md-12"><h3>{tr("login.passwordResetTitle")}</h3></div>
                        <div className="col-md-12">{tr("Nous vous enverrons un courriel contenant un lien. Veuillez cliquer sur ce lien pour réinitialiser votre mot de passe.")}</div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="col-md-12"><h5>{tr("login.passwordResetTitle")}</h5></div>
                    <div className="col-md-12">{tr("Nous vous enverrons un courriel contenant un lien. Veuillez cliquer sur ce lien pour réinitialiser votre mot de passe.")}</div>
                </div>
            );
        }
    }

    render(){
        var msgSendResetEmail = null;
        const emailToUse = this.getEmailToUse()

        if (this.state.showSuccessResetPasswordModal) {
            msgSendResetEmail = <modal.ConfirmOK 
                                    showCloseButton={false}
                                    messagehtml={tr("login.passwordResetEmailSuccess")}
                                    onOK={this.handleOnResetOK}
                                    showModal={this.state.showSuccessResetPasswordModal}
                                    container={this.modalContainerRef.current} />
        }

        if (this.state.showFailedResetPasswordModal) {
            msgSendResetEmail = <modal.ConfirmOK 
                                    showCloseButton={false}
                                    messagehtml={tr("login.passwordResetEmailFailed")}
                                    onOK={this.handleOnResetOK}
                                    showModal={this.state.showSuccessResetPasswordModal} 
                                    container={this.modalContainerRef.current} />
        }

        return (
            <div>
                <div ref={this.modalContainerRef} />
                {msgSendResetEmail}

                <div className="row">
                    {this.getHeadersForInteg(this.props.integ)}
                </div>
                <br/>
                <div className={cIf(["row", {"content-text": this.props.integ === "rese"}])}>
                    <div className="col-xs-8">
                        <input autoFocus className="form-control input-sm" type="text" 
                            onChange={(e) => this.handleOnChangeEmailPassword(e)} 
                            onKeyPress={(e) => this.handleOnKeyPress(e)}
                            value={emailToUse}>                     
                        </input>
                    </div>
                </div>
                <br/>
                <div className={cIf(["row", {"content-text": this.props.integ === "rese"}])}>
                    <div className="col-xs-8 btn-toolbar">
                        <button className="btn btn-default btn-md" type="button" onClick={() => this.handleOnCancel()}>{tr("login.cancel")}</button>
                        <button className="btn btn-primary btn-md" type="button" onClick={() => this.handleOnConfirm()}>{tr("login.confirm")}</button>
                    </div>
                </div>
            </div>
        );
    }
}

PasswordReset.propTypes = {
    onConfirmResetPassword: PropTypes.func,
    onCancelResetPassword: PropTypes.func,
    //onChangeEmailPassword: PropTypes.func,
    email: PropTypes.string,
};

export default PasswordReset;